
import React, { useState } from 'react';
import { AuthFormMode } from '@/lib/types';
import { useAuth } from '@/hooks/useAuth';
import FormFields from '@/components/auth/FormFields';
import SubmitButton from '@/components/auth/SubmitButton';
import ForgotPasswordDialog from '@/components/auth/ForgotPasswordDialog';

interface AuthFormProps {
  mode: AuthFormMode;
}

const AuthForm: React.FC<AuthFormProps> = ({ mode }) => {
  const {
    email,
    setEmail,
    password,
    setPassword,
    name,
    setName,
    isLoading,
    isSubmitting,
    authError,
    handleSubmit
  } = useAuth(mode);

  const [forgotPasswordOpen, setForgotPasswordOpen] = useState(false);

  return (
    <div className="animate-fade-in glass-card p-8 rounded-lg shadow-sm max-w-md w-full mx-auto">
      <div className="space-y-6">
        <div className="space-y-2 text-center">
          <h1 className="text-2xl font-semibold tracking-tight">
            {mode === 'login' ? 'Welcome back' : 'Create an account'}
          </h1>
          <p className="text-sm text-muted-foreground">
            {mode === 'login' 
              ? 'Enter your credentials to access your account' 
              : 'Enter your details to create your account'}
          </p>
        </div>

        <form onSubmit={handleSubmit} className="space-y-4">
          <FormFields
            mode={mode}
            email={email}
            setEmail={setEmail}
            password={password}
            setPassword={setPassword}
            name={name}
            setName={setName}
            isLoading={isLoading}
            onForgotPassword={() => setForgotPasswordOpen(true)}
          />

          {authError && (
            <p className="text-sm text-destructive">{authError}</p>
          )}

          <SubmitButton
            mode={mode}
            isLoading={isLoading}
            isSubmitting={isSubmitting}
          />
        </form>
      </div>

      <ForgotPasswordDialog 
        isOpen={forgotPasswordOpen}
        onOpenChange={setForgotPasswordOpen}
        defaultEmail={email}
      />
    </div>
  );
};

export default AuthForm;
